import { gql } from '@apollo/client'
// This is the same for public and resigned public profiles
export default gql`
  fragment InternationalAddress on InternationalAddress {
    addressLine1
    addressLine2
    addressLine3
    stateRegion
    zipPostalCode
    country
    phoneNumber
  }
`
